import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Slide from 'react-reveal/Slide';
import './Footer.css';

function Footer() {
    return (
        <div className="footer">
            <Container>
                <Slide bottom>
                <Row>
                    <Col sm={6} className="my-3">
                    <div className='footer__div'>
                        <h3 className='my-2'> Our Location</h3>
                        <h6 className='mt-1'> Lower Savanna Dakar Rd</h6>
                        <div>
                            Directly Opposite GreenSpan Mall
                        
                        </div>

                

                    
                    </div>
                    </Col>


                    <Col sm={6} className="my-3">
                    <div className='footer__div'>
                        <h3 className='my-2'>Quick Links</h3>
                        <div>
                            <a href='#slider'>Home</a>
                        </div>
                        <div>
                            <a href='#about'>About Us</a>
                        </div>
                        <div>
                            <a href='#services'>Services</a>
                        </div>
                        <div>
                            <a href='#partners'>Partners</a>
                        </div>
                        <div>
                            <a href='#contact'>Contact Us</a>
                        </div>
                        
                        
                        
                    </div>    
                    </Col>

                    <Col sm={6} className="my-3">
                        <div className='footer__div'>
                            <h3 className='my-2'>Opening Hours</h3>
                            <div>Monday: 8:00am - 9:00pm</div>
                            <div>Tuesday: 8:00am - 9:00pm</div>
                            <div>Wednesday: 8:00am - 9:00pm</div>
                            <div>Thursday: 8:00am - 9:00pm</div>
                            <div>Friday: 8:00am - 9:00pm</div>
                            <div>Saturday: 8:00am - 9:00pm</div>
                            <div>Closed on Sundays and</div> 
                            <div>Open on  Public Holidays upon Booking</div>

                        </div>
                    </Col>

                    <Col sm={6} className="my-3">
                    <div className='footer__div'>
                        <h3 className='my-2'> We are Social</h3>
                        <div className='footer__icons my-3'>
                            <i className="fab fa-facebook-f  fa-xl mx-2" ></i> 

                            <i className="fa-brands fa-twitter  fa-xl mx-2"></i>

                            <i className="fa-brands fa-instagram  fa-xl mx-2"></i>
                            
                        </div>
                        
                        <div><span> <i className="fa-solid fa-phone"></i> +254 112774429</span></div>
                        <div>royalsmilesclinic.com</div>
                        

                        

                    </div>
                    </Col>
                </Row>
                </Slide>
                
            </Container>
            <Row>
                <div className='footer__div copyright'> Designed and Developed by Abungu Brighton | copyright &copy;2022</div>
            </Row>
        
        </div>
    );
}

export default Footer;
